import React from 'react';
import { FDStack, FDIcon, FDBodyText } from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const DueDateString = ({ value }) => {
  if (!value) {
    return null;
  }

  return (
    <FDStack alignItems={'center'} spacing={1}>
      <FDIcon icon={'dateRange'} color={'textPrimary'} />
      <FDBodyText size={'md'} value={value} />
    </FDStack>
  );
};
DueDateString.propTypes = {
  value: PropTypes.string.isRequired,
};
